module.exports = __webpack_public_path__ + "static/media/facebook.04136ace.svg";